<template>
  <HeaderTrade />

  <main id="container" class="not-found-container">
    <section id="contents" class="not-found" aria-labelledby="not-found-title">
      <p class="not-found__code">404</p>
      <h1 id="not-found-title">페이지를 찾을 수 없습니다.</h1>
      <p class="not-found__description">
        주소가 잘못되었거나 페이지가 이동 또는 삭제되었을 수 있습니다.
      </p>
      <div class="not-found__actions">
        <button type="button" class="btn btn-outline-secondary" @click="goBack">이전 페이지</button>
        <button type="button" class="btn btn-primary" @click="goHome">홈으로</button>
      </div>
    </section>
  </main>

  <Footer />
</template>

<script>
import { useRouter } from 'vue-router';
import HeaderTrade from '@/components/HeaderTrade.vue';
import Footer from '@/components/Footer.vue';

export default {
  components: {
    HeaderTrade,
    Footer,
  },
  setup() {
    const router = useRouter();

    const goBack = () => {
      if (window.history.length > 1) {
        router.back();
        return;
      }

      router.push({ name: 'Home' });
    };

    const goHome = () => router.push({ name: 'Home' });

    return { goBack, goHome };
  },
};
</script>

<style scoped>
.not-found-container {
  min-height: 440px;
}

.not-found {
  display: flex;
  min-height: 440px;
  padding: 56px 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.not-found__code {
  margin: 0;
  color: #0d6efd;
  font-size: 60px;
  font-weight: 700;
  line-height: 1;
}

.not-found h1 {
  margin: 20px 0 12px;
  font-size: 22px;
  font-weight: 700;
}

.not-found__description {
  margin: 0;
  color: #6c757d;
  line-height: 1.6;
}

.not-found__actions {
  display: flex;
  gap: 8px;
  margin-top: 28px;
}
</style>
